import { cn } from "@/lib/utils"

import { SearchLayout } from "./search-layout"

type RegionProps = React.ComponentProps<"div"> & {
  children: React.ReactNode
}

function SearchWorkspace({ children }: { children: React.ReactNode }) {
  return (
    <SearchLayout>
      <div className="flex min-h-0 flex-col sm:flex-row">{children}</div>
    </SearchLayout>
  )
}

function Sidebar({ className, children, ...props }: RegionProps) {
  return (
    <aside
      className={cn(
        "flex h-auto w-full flex-col gap-4 p-6 sm:h-full sm:w-1/5 sm:border-r",
        className,
      )}
      {...props}
    >
      {children}
    </aside>
  )
}

function Content({ className, children, ...props }: RegionProps) {
  return (
    <main
      className={cn("flex min-w-0 flex-1 flex-col gap-4 p-6", className)}
      {...props}
    >
      {children}
    </main>
  )
}

SearchWorkspace.Sidebar = Sidebar
SearchWorkspace.Content = Content

export { SearchWorkspace }
